import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { AuthService } from "@core/auth.service";
import { IonicModule, ModalController, NavParams } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { FreeWeekConfirmationComponent } from "src/app/components/free-week-confirmation/free-week-confirmation.component";
import { LeaveConfirmationComponent } from "src/app/components/leave-confirmation/leave-confirmation.component";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { HeaderComponent } from "../../../components/header/header.component";
import { MixpanelService } from "../../../services/mixpanel.service";
import { DontUnderstandComponent } from "../leave-syndicate-reasons/dont-understand/dont-understand.component";
import { DontWantToPlayComponent } from "../leave-syndicate-reasons/dont-want-to-play/dont-want-to-play.component";
import { NotWinningComponent } from "../leave-syndicate-reasons/not-winning/not-winning.component";
import { SomethingElseComponent } from "../leave-syndicate-reasons/something-else/something-else.component";
import { TooExpensiveComponent } from "../leave-syndicate-reasons/too-expensive/too-expensive.component";
import { WasNotAwareComponent } from "../leave-syndicate-reasons/was-not-aware/was-not-aware.component";

@Component({
    selector: "app-leave-syndicate",
    templateUrl: "./leave-syndicate.component.html",
    styleUrls: ["./leave-syndicate.component.scss"],
    standalone: true,
    imports: [
        HeaderComponent,
        IonicModule,
        TranslatePipe,
    ],
})
export class LeaveSyndicateComponent implements OnInit {
  pageTitle = "Leave syndicate";
  syndicate: any;
  userId: string;

  constructor(
    private modalCtrl: ModalController,
    private matDialog: MatDialog,
    private mixPanelService: MixpanelService,
    private navParams: NavParams,
    public translate: TranslateService,
    private GTMsegment: GTMSegmentService,
    private authService: AuthService,
  ) {
    this.GTMsegment.GTMPopupInitialization("leaveReasonSyndicatepopup");
  }

  async ngOnInit() {
    await this.authService
      ?.getUid("LeaveSyndicateComponent")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error: any) => {
        return error;
      });
    this.syndicate = this.navParams?.data?.syndicate;
    this.translate.get(['leave-syndicate.pageTitle']).subscribe((res: string) => {
      this.pageTitle = (res["leave-syndicate.pageTitle"])
    }, err => { return (err) })
  }

  async leaveReason(reason) {
    this.mixPanelService.init(this.userId);
    let modelComponent;
    if (reason === "dontUnderstand") {
      modelComponent = DontUnderstandComponent;
      this.mixPanelService.syndicateCancellationMixpanel(
        "Don’t understand how it works",
        "Leave syndicate",
        "DontUnderstandComponent",
        "DontUnderstandComponent"
      );
    } else if (reason === "dontWantToPlay") {
      modelComponent = DontWantToPlayComponent;
      this.mixPanelService.syndicateCancellationMixpanel(
        "I don’t want to play weekly",
        "Leave syndicate",
        "DontWantToPlayComponent",
        "DontWantToPlayComponent"
      );
    } else if (reason === "tooExpensive") {
      modelComponent = TooExpensiveComponent;
      this.mixPanelService.syndicateCancellationMixpanel(
        "It’s too expensive for me",
        "Leave syndicate",
        "TooExpensiveComponent",
        "TooExpensiveComponent"
      );
    } else if (reason === "notWinning") {
      modelComponent = NotWinningComponent;
      this.mixPanelService.syndicateCancellationMixpanel(
        "I’m not winning enough",
        "Leave syndicate",
        "NotWinningComponent",
        "NotWinningComponent"
      );
    } else if (reason === "wasNotAware") {
      modelComponent = WasNotAwareComponent;
      this.mixPanelService.syndicateCancellationMixpanel(
        "I wasn't aware it was ongoing",
        "Leave syndicate",
        "WasNotAwareComponent",
        "WasNotAwareComponent"
      );
    } else if (reason === "somethingElse") {
      modelComponent = SomethingElseComponent;
      this.mixPanelService.syndicateCancellationMixpanel(
        "Something else",
        "Leave syndicate",
        "SomethingElseComponent",
        "SomethingElseComponent"
      );
    }
    const leaveReason = await this.modalCtrl.create({
      component: modelComponent,
      cssClass: "modal-fullScreen",
      componentProps: {
        s_name: this.syndicate?.syndicate_name ? this.syndicate?.syndicate_name : this.syndicate?.ps_name,
      },
    });
    leaveReason.onDidDismiss().then((res) => {
      if (res && res?.data) {
        if (res?.data?.pauseSyndicate) {
          this.goBack();
        } else {
          setTimeout(() => {
            this.modalCtrl.dismiss(res?.data).catch((err) => {
              return err;
            });
          }, 100);
        }
      }
    }).catch((err) => {
      return err;
    });
    return await leaveReason.present();
  }

  leaveConfirmation() {
    this.matDialog.open(LeaveConfirmationComponent, {
      panelClass: "leaveConfirmation-dailog",
    });
  }

  freeWeekConfirmation() {
    this.matDialog.open(FreeWeekConfirmationComponent, {
      panelClass: "free-week-confirmation-dialog",
    });
  }

  goBack() {
    this.modalCtrl.dismiss().catch(err => { return err });
  }
}
